import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/Clientes.css";

import cliente1 from "../assets/clientes/baptistaleal.png";
import cliente2 from "../assets/clientes/CME.png";
import cliente3 from "../assets/clientes/fiepe.png";
import cliente4 from "../assets/clientes/SECOVIPB.png"
import cliente5 from "../assets/clientes/VMV.png";
import cliente6 from "../assets/clientes/correta.png";
import cliente7 from "../assets/clientes/manaira.png";
import cliente8 from "../assets/clientes/petrobras.gif";

const logos = [
  cliente1,
  cliente2,
  cliente3,
  cliente4,
  cliente5,
  cliente6,
  cliente7,
  cliente8,
];

const ITEMS_PER_SLIDE = 4;

export default function Clientes() {
  const [index, setIndex] = useState(0);

  // cria os slides
  const slides = [];
  for (let i = 0; i < logos.length; i += ITEMS_PER_SLIDE) {
    slides.push(logos.slice(i, i + ITEMS_PER_SLIDE));
  }

  // autoplay
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="clientes-section">
      <h2 className="clientes-titulo">Nossos Clientes</h2>
      <p className="clientes-subtitulo">
        Empresas que confiam em nosso trabalho
      </p>

      <div className="clientes-container">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            className="clientes-faixa"
            initial={{ opacity: 0, x: 80 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -80 }}
            transition={{ duration: 0.5 }}
          >
            {slides[index].map((logo, i) => (
              <img
                key={i}
                src={logo}
                alt={`Cliente ${i + 1}`}
                className="clientes-logo"
              />
            ))}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Bolinhas */}
      <div className="clientes-bolinhas">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`bolinha ${i === index ? "ativa" : ""}`}
            onClick={() => setIndex(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
